import React, { useEffect, useState } from 'react';
import i18n from 'i18n-js';
import Localization from '../../../shared/Localization';
import Grid from '@material-ui/core/Grid';
import { InputBase, Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import { ContentPhoto } from '../../shared/ContentPhoto/ContentPhoto';
import { Search } from '../../../constants/Icons';
import { IWildlifeServiceObj } from '../../../shared/apiServices/IApiInterfaces';
import IdentificationGuideApiHelper from './IdentificationGuideApiHelper';
import Toast from '../../../shared/Notifications/Toast';
import PhotoGallery from '../../shared/PhotoGallery/PhotoGallery';

const IdentificationGuide = () => {
  const [local, setLocal] = useState<typeof i18n | null>(null);
  const [open, setOpen] = React.useState(false);
  const [fieldGuide, setFieldGuide] = useState<Array<IWildlifeServiceObj>>([]);
  const [search, setSearch] = useState<string>('');
  const [photos, setPhotos] = useState<Array<string>>([]);

  useEffect(() => {
    const setNewLocal = async () => {
      const newLocal = await Localization('en');
      setLocal(newLocal);
    };

    const getWildlife = async () => {
      const wildlife: IWildlifeServiceObj[] =
        await IdentificationGuideApiHelper.getAllWildlife();
      setFieldGuide(wildlife);
    };

    setNewLocal();
    getWildlife();
  }, []);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target?.value || '');
  };

  const filteredFieldGuides = (): Array<IWildlifeServiceObj> => {
    if (search === '') return fieldGuide;

    return fieldGuide?.filter((f) =>
      f.name.toLowerCase().includes(search.toLowerCase())
    );
  };

  const firstOrDefault = (wildlife: IWildlifeServiceObj): string => {
    if (!wildlife.imageUrls || wildlife.imageUrls.length <= 0)
      return 'default.png';

    return wildlife.imageUrls[0];
  };

  const handleClick = (wildlife: IWildlifeServiceObj) => {
    if (!wildlife.imageUrls) {
      Toast.show('No images available');
      return;
    }

    setPhotos(wildlife?.imageUrls || []);
    setOpen(true);
  };

  const handleModalClose = () => {
    setOpen(false);
    setPhotos([]);    
  }

  const fieldGuides = (): JSX.Element[] => {
    return filteredFieldGuides().map((fg) => (
      <Grid item md={4} key={fg.id}>
        <Grid container spacing={1}>
          <Grid
            item
            onClick={(e) => {
              handleClick(fg);
            }}
            style={{ cursor: 'pointer' }}
          >
            <ContentPhoto
              url={firstOrDefault(fg)}
              height="180px"
              width="200px"
            />
          </Grid>
          <Grid item xs>
            <Typography variant="h6">{fg.name || ''}</Typography>
            <Typography variant="body2" color="textSecondary">
              {fg.scientificName || ''}
            </Typography>
            <Typography variant="body2">{fg.description || ''}</Typography>
          </Grid>
        </Grid>
      </Grid>
    ));
  };

  const searchBox: JSX.Element = (
    <div style={{ margin: '0 0 15px' }}>
      <InputBase onChange={handleSearch} placeholder="Search" />
      <IconButton aria-label="search">
        <a className="action-icon">{Search}</a>
      </IconButton>
    </div>
  );

  const galleryModal = (
    <Modal
      open={open}
      onClose={handleModalClose}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <PhotoGallery
        photoNames={photos}
      ></PhotoGallery>
    </Modal>
  );

  return (
    <>
      <p>{local?.t('identificationGuide.title')}</p>
      {searchBox}
      <Grid container spacing={4}>
        {fieldGuides()}
      </Grid>
      {galleryModal}
    </>
  );
};

export default IdentificationGuide;
